
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("l3mnF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "expAttributes", () => $3f4dc346165f587c$export$6fb6758aa812bdfb);
$parcel$export(module.exports, "default", () => $3f4dc346165f587c$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $1Seuh = parcelRequire("1Seuh");

var $bWfiu = parcelRequire("bWfiu");

var $7kQOw = parcelRequire("7kQOw");

var $kweMg = parcelRequire("kweMg");

var $6eFvr = parcelRequire("6eFvr");

var $9r7BT = parcelRequire("9r7BT");

var $cBCgC = parcelRequire("cBCgC");

var $4R6GH = parcelRequire("4R6GH");

var $hh0bW = parcelRequire("hh0bW");

var $JIPqS = parcelRequire("JIPqS");

var $iyrll = parcelRequire("iyrll");

var $iLC4C = parcelRequire("iLC4C");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $gh1hi = parcelRequire("gh1hi");

var $wlDl0 = parcelRequire("wlDl0");

var $GQeXq = parcelRequire("GQeXq");

var $aKqCL = parcelRequire("aKqCL");

var $8SHRg = parcelRequire("8SHRg");

var $b6VJM = parcelRequire("b6VJM");

var $ed4EL = parcelRequire("ed4EL");

var $5eMyF = parcelRequire("5eMyF");

var $ePdfe = parcelRequire("ePdfe");

var $4mgKT = parcelRequire("4mgKT");
const $3f4dc346165f587c$var$ADD_GADGET_PANEL_HEADING_ID = 'add-gadget-panel-heading';
const $3f4dc346165f587c$export$6fb6758aa812bdfb = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.ADD_GADGET_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {}
};
function $3f4dc346165f587c$export$2e2bcd8739ae039() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const allCategoryLabel = (0, $5uXOq.useMemo)(()=>formatMessage((0, $5eMyF.default).all), [
        formatMessage
    ]);
    const { onCloseRightPanel: onCloseRightPanel, onFocusPanel: onFocusPanel } = (0, $GQeXq.useRightPanelToggle)();
    const { focusKey: focusKey } = (0, $GQeXq.useRightPanelState)();
    const inputRef = (0, $5uXOq.useRef)(null);
    const { data: data } = (0, $gh1hi.useDashboardResource)();
    const [activeTag, setActiveTag] = (0, $5uXOq.useState)(allCategoryLabel);
    const [searchText, setSearchText] = (0, $5uXOq.useState)('');
    const onBeforeGadgetAdded = (0, $iyrll.useOnAddedGadget)();
    const { addGadget: addGadget, getIsLoading: getIsAddGadgetLoading, getIsDisabled: getIsAddGadgetDisabled } = (0, $aKqCL.useAddGadget)({
        onBeforeGadgetAdded: onBeforeGadgetAdded
    });
    const { data: gadgets, loading: loading, error: error } = (0, $gh1hi.useGadgetDirectoryResource)();
    const [numOfGadgetForScreenReader, setNumOfGadgetForScreenReader] = (0, $5uXOq.useState)(gadgets && gadgets.length || 0); // delay this a bit so that screen reader can read the number of gadgets after search event
    const debouncedUpdateNumOfGadget = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((numOfGadget)=>setNumOfGadgetForScreenReader(numOfGadget), 1000, {
        trailing: true
    }));
    const onSearchTextChange = (0, $5uXOq.useCallback)((event)=>{
        const searchString = event.target.value.toLowerCase();
        setSearchText(searchString);
    }, []);
    const onToggleTag = (0, $5uXOq.useCallback)((tag)=>{
        if (activeTag !== tag) setActiveTag(tag);
        else setActiveTag(allCategoryLabel);
    }, [
        activeTag,
        allCategoryLabel
    ]);
    const categories = (0, $5uXOq.useMemo)(()=>{
        if (gadgets != null) return (0, $4mgKT.getCategoriesFromGadgetsData)(gadgets, allCategoryLabel);
        return null;
    }, [
        gadgets,
        allCategoryLabel
    ]);
    const displayData = (0, $5uXOq.useMemo)(()=>{
        if (categories == null) return null;
        const filteredCategories = {
            ...categories
        };
        if (searchText.length > 0) Object.keys(categories).forEach((category)=>{
            filteredCategories[category] = categories[category].filter((item)=>(0, $4mgKT.matchSearchText)(item, searchText));
        });
        const tags = Object.keys(filteredCategories).map((category)=>({
                label: category,
                count: filteredCategories[category].length
            }));
        const sortedGadgets = (0, $4mgKT.sortGadget)(filteredCategories[activeTag]);
        debouncedUpdateNumOfGadget.current(sortedGadgets.length);
        return {
            sortedGadgets: sortedGadgets,
            tags: tags
        };
    }, [
        activeTag,
        debouncedUpdateNumOfGadget,
        searchText,
        categories
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error instanceof Error) (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error,
            sendSuccessExperience: ()=>{
                (0, $hh0bW.default)({
                    ...$3f4dc346165f587c$export$6fb6758aa812bdfb,
                    wasExperienceSuccesful: true
                });
            },
            sendFailedExperience: ()=>{
                (0, $hh0bW.default)({
                    ...$3f4dc346165f587c$export$6fb6758aa812bdfb,
                    wasExperienceSuccesful: false
                });
            },
            logErrorEvent: (reason)=>{
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: (0, $JIPqS.ADD_GADGET_EXPERIENCE),
                        packageName: (0, $wlDl0.PACKAGE_NAME)
                    },
                    attributes: {
                        reason: reason,
                        endpoint: 'gadgetDirectory'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    }, [
        error
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        onFocusPanel(()=>inputRef?.current?.focus?.());
    }, [
        focusKey,
        onFocusPanel
    ]);
    const onKeyDownHandler = (0, $5uXOq.useCallback)(({ key: key })=>{
        if (key === 'Escape') onCloseRightPanel();
    }, [
        onCloseRightPanel
    ]);
    if (loading === true || data == null || !error && (gadgets == null || gadgets.length === 0) || displayData == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePdfe.PanelContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8SHRg.AddGadgetPanelSkeleton), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "add-gadget",
        packageName: (0, $wlDl0.PACKAGE_NAME),
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePdfe.PanelContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6VJM.Fallback), {
                type: (0, $b6VJM.FALLBACK_TYPE).ERROR
            })),
        attributes: {
            task: (0, $JIPqS.ADD_GADGET_EXPERIENCE),
            reason: 'AddGadgetPanel ErrorBoundary'
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePdfe.PanelContainer), {
        "data-testid": "dashboard-edit.ui.header-editable.add-gadget-button.add-gadget-panel.panel-container",
        "aria-labelledby": $3f4dc346165f587c$var$ADD_GADGET_PANEL_HEADING_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f4dc346165f587c$var$PanelDirectoryContainer, {
        onKeyDown: onKeyDownHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePdfe.PanelHeaderContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePdfe.Header), null, (0, $4R6GH.fg)('jfp_a11y_autodev_fix_gadget_heading') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "xsmall",
        id: $3f4dc346165f587c$var$ADD_GADGET_PANEL_HEADING_ID,
        as: "h2"
    }, formatMessage((0, $5eMyF.default).addAGadget)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "xsmall",
        id: $3f4dc346165f587c$var$ADD_GADGET_PANEL_HEADING_ID
    }, formatMessage((0, $5eMyF.default).addAGadget)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        onClick: onCloseRightPanel,
        appearance: "subtle",
        label: formatMessage((0, $5eMyF.default).closeAddGadgetPanel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kweMg)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
        ref: inputRef,
        name: "basic",
        "aria-label": formatMessage((0, $5eMyF.default).searchGadgets),
        placeholder: formatMessage((0, $5eMyF.default).searchGadgets),
        onChange: onSearchTextChange,
        testId: "dashboard-edit.ui.header-editable.add-gadget-button.add-gadget-panel.dashboard-add-gadget-search",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7kQOw))), {
            color: "var(--ds-icon-accent-gray, #758195)",
            label: "",
            spacing: "spacious"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cBCgC.default), {
        "aria-live": "polite",
        "aria-relevant": "text",
        role: "status"
    }, formatMessage((0, $5eMyF.default).searchGadgetsResult, {
        num: numOfGadgetForScreenReader
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePdfe.CategoryLozengeGroup), null, displayData.tags.map((tag)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePdfe.CategoryLozengeClickable), {
            isActive: activeTag === tag.label ? 'isActive' : '',
            "aria-pressed": activeTag === tag.label,
            key: tag.label,
            onClick: ()=>onToggleTag(tag.label)
        }, tag.label, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            weight: "bold",
            color: activeTag === tag.label ? 'color.text.accent.blue' : 'color.text.subtle'
        }, tag.count))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePdfe.PanelContentContainer), null, !error && gadgets != null && gadgets.length > 0 && displayData.sortedGadgets.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6VJM.Fallback), {
        type: (0, $b6VJM.FALLBACK_TYPE).NOTFOUND
    }), displayData.sortedGadgets.map((g)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ed4EL.GadgetDirectoryItem), {
            gadgetDirectoryItem: g,
            key: g.id,
            onAddGadget: ()=>addGadget(g),
            getIsLoading: getIsAddGadgetLoading,
            getIsDisabled: getIsAddGadgetDisabled
        })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6VJM.Fallback), {
        type: (0, $b6VJM.FALLBACK_TYPE).ERROR
    })))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f4dc346165f587c$var$PanelDirectoryContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vchhusvi _1reo15vq _18m91wug _4t3i1osq _1bsb1osq _1xi2idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aKqCL", function(module, exports) {

$parcel$export(module.exports, "useAddGadget", () => $117c0fe5a919c703$export$ad06e7d30063ef9d);

var $5uXOq = parcelRequire("5uXOq");

var $hh0bW = parcelRequire("hh0bW");

var $2YZCu = parcelRequire("2YZCu");

var $JIPqS = parcelRequire("JIPqS");

var $7RGnr = parcelRequire("7RGnr");

var $cmJHP = parcelRequire("cmJHP");

var $iLC4C = parcelRequire("iLC4C");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $gh1hi = parcelRequire("gh1hi");

var $wlDl0 = parcelRequire("wlDl0");

var $GQeXq = parcelRequire("GQeXq");

var $eeAmR = parcelRequire("eeAmR");

var $9yD8A = parcelRequire("9yD8A");
const $117c0fe5a919c703$export$6fb6758aa812bdfb = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.ADD_GADGET_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $117c0fe5a919c703$var$errorFlagAttributes = {
    key: (0, $7HGHK.toFlagId)('gadgetAddError'),
    type: 'error',
    title: (0, $9yD8A.default).errorFlagTitle,
    description: (0, $9yD8A.default).errorFlagDescription,
    messageId: 'dashboard-edit.services.add-gadget.error-flag-attributes.error',
    messageType: 'transactional',
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    actions: [
        {
            content: (0, $9yD8A.default).errorFlagAction,
            onClick: ()=>window.location.reload()
        }
    ]
};
const $117c0fe5a919c703$export$ad06e7d30063ef9d = ({ onBeforeGadgetAdded: onBeforeGadgetAdded })=>{
    const { data: data, update: update } = (0, $gh1hi.useDashboardResource)();
    const [addGadgetLoadingId, setAddGadgetLoadingId] = (0, $5uXOq.useState)(null);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { panelId: panelId } = (0, $GQeXq.useRightPanelState)();
    const { canAddGadgetWithinLimit: canAddGadgetWithinLimit, showGadgetLimitFlag: showGadgetLimitFlag } = (0, $eeAmR.useAddGadgetWithinLimit)((0, $wlDl0.MAX_GADGETS_COUNT_INCLUDE_IGNORED_GADGETS), (0, $wlDl0.MAX_ALLOWED_GADGETS_COUNT));
    const columnIndex = panelId?.slice(panelId.length - 1);
    const addGadget = (0, $5uXOq.useCallback)((gadget)=>{
        if (data == null) return;
        const isGadgetIgnored = Object.keys((0, $wlDl0.IGNORED_GADGETS_FROM_COUNT_MAP)).includes(gadget.id);
        if (!canAddGadgetWithinLimit(data.gadgets, isGadgetIgnored)) {
            showGadgetLimitFlag();
            return;
        }
        setAddGadgetLoadingId(gadget.id);
        const dashboardResourceUrl = data.resourceUrl;
        const type = gadget.specUri != null && gadget.specUri.trim().length > 0 && 'gadget' || gadget.isForgeGadget && 'forge-gadget' || 'dashboard-item';
        const dashboardItemId = gadget.specUri != null && gadget.specUri.trim().length > 0 && gadget.specUri || gadget.isForgeGadget && gadget.id || gadget.completeModuleKey;
        // see https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/commits/c93a98012d73ede4496464312f4fdda1f73abde3#dashboard-plugin/src/main/resources/js/dashboard-service.js
        // verified that localeLang and localeCountry are no longer needed
        (0, $eusud.performPostRequest)(`${dashboardResourceUrl}.json`, {
            body: JSON.stringify({
                dashboardItemId: dashboardItemId,
                type: type,
                columnIndex: columnIndex
            })
        }).then((gadgetData)=>{
            onBeforeGadgetAdded?.(gadgetData.id);
            update((0, $cmJHP.lensGadgetsList)((gadgets)=>[
                    ...(0, $7RGnr.mapToReactGadgets)([
                        gadgetData
                    ]),
                    ...gadgets
                ]));
            (0, $hh0bW.default)({
                ...$117c0fe5a919c703$export$6fb6758aa812bdfb,
                wasExperienceSuccesful: true
            });
            (0, $2YZCu.default).safeInfoWithoutCustomerData('spa-apps.dashboard', 'Add gadget');
        }).catch((error)=>{
            if (error.errors?.length > 0 && error.errors[0]?.field === 'columnIndex' && error.errors[0]?.error) {
                const invalidColumnFlagAttributes = {
                    key: (0, $7HGHK.toFlagId)('gadgetAddError'),
                    type: 'error',
                    title: (0, $9yD8A.default).invalidColumnFlagTitle,
                    description: error.errors[0].error,
                    messageId: 'dashboard-edit.services.add-gadget.invalid-column-flag-attributes.error',
                    messageType: 'transactional',
                    actions: [
                        {
                            content: (0, $9yD8A.default).errorFlagAction,
                            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                            onClick: ()=>window.location.reload()
                        }
                    ]
                };
                showFlag(invalidColumnFlagAttributes);
            } else showFlag($117c0fe5a919c703$var$errorFlagAttributes);
            (0, $iLC4C.handleFetchErrorAsExperience)({
                error: error,
                sendSuccessExperience: ()=>{
                    (0, $hh0bW.default)({
                        ...$117c0fe5a919c703$export$6fb6758aa812bdfb,
                        wasExperienceSuccesful: true
                    });
                },
                sendFailedExperience: ()=>{
                    (0, $hh0bW.default)({
                        ...$117c0fe5a919c703$export$6fb6758aa812bdfb,
                        wasExperienceSuccesful: false
                    });
                },
                logErrorEvent: (reason)=>{
                    (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: (0, $JIPqS.ADD_GADGET_EXPERIENCE),
                            packageName: (0, $wlDl0.PACKAGE_NAME)
                        },
                        attributes: {
                            reason: reason,
                            endpoint: 'addGadget'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        }).finally(()=>{
            setAddGadgetLoadingId(null);
        });
    }, [
        data,
        columnIndex,
        canAddGadgetWithinLimit,
        showGadgetLimitFlag,
        showFlag,
        onBeforeGadgetAdded,
        update
    ]);
    const getIsLoading = (0, $5uXOq.useCallback)((id)=>id === addGadgetLoadingId, [
        addGadgetLoadingId
    ]);
    const getIsDisabled = (0, $5uXOq.useCallback)((id)=>addGadgetLoadingId !== null && id !== addGadgetLoadingId, [
        addGadgetLoadingId
    ]);
    return {
        addGadget: addGadget,
        getIsLoading: getIsLoading,
        getIsDisabled: getIsDisabled
    };
};

});
parcelRegister("9yD8A", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f91fdae0cc49608$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0f91fdae0cc49608$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "dashboard-edit.services.add-gadget.error-flag-title",
        "defaultMessage": "Error"
    },
    errorFlagDescription: {
        "id": "dashboard-edit.services.add-gadget.error-flag-description",
        "defaultMessage": "We cannot add any new gadgets at the moment"
    },
    errorFlagAction: {
        "id": "dashboard-edit.services.add-gadget.error-flag-action",
        "defaultMessage": "Refresh"
    },
    invalidColumnFlagTitle: {
        "id": "dashboard-edit.services.add-gadget.invalid-column-flag-title",
        "defaultMessage": "We couldn\u2019t add the gadget"
    }
});

});


parcelRegister("ed4EL", function(module, exports) {

$parcel$export(module.exports, "GadgetDirectoryItem", () => $969931bd81898dfc$export$35b018f09452624f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $bMFGq = parcelRequire("bMFGq");

var $bWfiu = parcelRequire("bWfiu");

var $0yZbT = parcelRequire("0yZbT");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $JIPqS = parcelRequire("JIPqS");

var $eXVsp = parcelRequire("eXVsp");

var $b3IiT = parcelRequire("b3IiT");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $hejMu = parcelRequire("hejMu");
const $969931bd81898dfc$var$GADGET_PREVIEW_WIDTH = 75;
const $969931bd81898dfc$export$35b018f09452624f = ({ gadgetDirectoryItem: gadgetDirectoryItem, onAddGadget: onAddGadget, getIsLoading: getIsLoading, getIsDisabled: getIsDisabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isDeprecated = (0, $b3IiT.checkGadgetType)((0, $JIPqS.DEPRECATED_GADGETS_MAP), gadgetDirectoryItem.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($969931bd81898dfc$var$GadgetItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($969931bd81898dfc$var$GadgetItemContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($969931bd81898dfc$var$GadgetPreview, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($969931bd81898dfc$var$GadgetThumbnail, {
        src: gadgetDirectoryItem.thumbnailUri,
        role: "img",
        "aria-label": gadgetDirectoryItem.titleLabel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
        appearance: "primary",
        spacing: "compact",
        shouldFitContainer: true,
        onClick: onAddGadget,
        isLoading: getIsLoading(gadgetDirectoryItem.id),
        isDisabled: getIsDisabled(gadgetDirectoryItem.id),
        testId: "dashboard-edit.ui.header-editable.add-gadget-button.add-gadget-panel.gadget-directory-item.dashboard-add-gadget-button",
        "aria-label": formatMessage((0, $hejMu.default).addButtonlabel, {
            title: gadgetDirectoryItem.titleLabel
        })
    }, formatMessage((0, $hejMu.default).addThisGadget))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($969931bd81898dfc$var$GadgetDetailWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $969931bd81898dfc$var$gadgetTitleWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        as: "h3",
        size: "xsmall",
        testId: "dashboard-edit.ui.header-editable.add-gadget-button.add-gadget-panel.gadget-directory-item.heading"
    }, gadgetDirectoryItem.titleLabel), isDeprecated && (0, $4R6GH.fg)('endeavour_gadget_deprecation_banner_v1') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eXVsp.DeprecationTooltip), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text",
        size: "UNSAFE_small"
    }, formatMessage((0, $hejMu.default).by, {
        authorLabel: gadgetDirectoryItem.authorLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, gadgetDirectoryItem.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($969931bd81898dfc$var$CategoryLozengeGroup, null, gadgetDirectoryItem.categories.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            key: c,
            paddingInline: "space.100",
            paddingBlock: "space.0",
            backgroundColor: "color.background.accent.gray.subtler",
            xcss: $969931bd81898dfc$var$gadgetCategoryLozengeStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            color: "color.text.subtle"
        }, c)))))));
};
const $969931bd81898dfc$var$gadgetTitleWrapperStyles = (0, $2s57o.xcss)({
    marginBottom: 'space.025',
    display: 'flex',
    flexDirection: 'row'
});
const $969931bd81898dfc$var$gadgetCategoryLozengeStyles = (0, $2s57o.xcss)({
    borderRadius: '13px',
    marginRight: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $969931bd81898dfc$var$GadgetThumbnail = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $lD23V.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _189et94y _1dqonqa1 _1h6dmuej _bfhk18uv _1itk2pcs _12vemgnk _1lrw1f51 _1bsb1osq _4t3i1nhl _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $969931bd81898dfc$var$GadgetPreview = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl8ved",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $969931bd81898dfc$var$CategoryLozengeGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/design-system/use-primitives, @atlaskit/ui-styling-standard/no-styled
const $969931bd81898dfc$var$GadgetItemWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $969931bd81898dfc$var$GadgetDetailWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvutpp _125x1fxt _clfd1b66 _q0a5u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $969931bd81898dfc$var$GadgetItemContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h _1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hejMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8558e14b879461f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e8558e14b879461f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    by: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.gadget-directory-item.by",
        "defaultMessage": "By {authorLabel}"
    },
    addThisGadget: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.gadget-directory-item.add-this-gadget",
        "defaultMessage": "Add"
    },
    addButtonlabel: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.gadget-directory-item.add-buttonlabel",
        "defaultMessage": "Add {title}"
    }
});

});


parcelRegister("5eMyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9cc317cadf07947$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d9cc317cadf07947$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    all: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.all",
        "defaultMessage": "All"
    },
    addAGadget: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.add-a-gadget",
        "defaultMessage": "Add a Gadget"
    },
    searchGadgets: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.search-gadgets",
        "defaultMessage": "Search gadgets"
    },
    searchGadgetsResult: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.search-gadgets-result",
        "defaultMessage": "{num} {num, plural, one {gadget} other {gadgets}} found"
    },
    closeAddGadgetPanel: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.close-add-gadget-panel",
        "defaultMessage": "Close the add gadget panel"
    }
});

});

parcelRegister("4mgKT", function(module, exports) {

$parcel$export(module.exports, "matchSearchText", () => $4ba5a511b3eb7f94$export$383fdb1409a43aa0);
$parcel$export(module.exports, "sortGadget", () => $4ba5a511b3eb7f94$export$968760dda916426d);
$parcel$export(module.exports, "getCategoriesFromGadgetsData", () => $4ba5a511b3eb7f94$export$1c92b3b9099187c9);
const $4ba5a511b3eb7f94$export$383fdb1409a43aa0 = (item, searchText)=>item.id.toLowerCase().includes(searchText) || item.titleLabel.toLowerCase().includes(searchText) || item.authorLabel.toLowerCase().includes(searchText) || item.description.toLowerCase().includes(searchText);
const $4ba5a511b3eb7f94$export$968760dda916426d = (gadgets)=>gadgets.sort((gadget1, gadget2)=>{
        const title1 = gadget1.titleLabel?.toLowerCase();
        const title2 = gadget2.titleLabel?.toLowerCase();
        // if undefined, we put them at the bottom
        if (title2 == null) {
            if (title1 != null) return -1;
            return 1;
        }
        if (title1 < title2) return -1;
        if (title1 > title2) return 1;
        return 0;
    });
const $4ba5a511b3eb7f94$export$1c92b3b9099187c9 = (gadgets, allCategoryLabel)=>gadgets.reduce((accumulator, currentGadget)=>{
        currentGadget.categories.forEach((category)=>{
            if (accumulator[category]) accumulator[category].push(currentGadget);
            else accumulator[category] = [
                currentGadget
            ];
        });
        return accumulator;
    }, {
        [allCategoryLabel]: gadgets
    });

});



//# sourceMappingURL=async-add-gadget-panel.3e1a8ad6.js.map
